import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { TransportDocumentService } from '../../services/transport-document.service';
import { formatDateOnlyISO } from '../../utils/date-utils';
import { ReportService } from '../../services/report-service';
export const loading = writable(false);
export const filterInitialized = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList() {
    if (get(filterInitialized) == false) {
        filterInitialized.set(true);
        // FIXME: here phaseCodeId is fixed... it should be the phase code of Macellazione
        filter.set({ criteria: { phaseCodeId: 2, phaseCode: "M", lotNumber: "" }, params: null, sorting: "" });
        pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    }
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    let _filter = get(filter);
    let _currPhaseCode = _filter.criteria.phaseCode;
    if (!_currPhaseCode)
        _currPhaseCode = "M";
    if (oid == 0) {
        record.set({
            oid: 0,
            documentDate: formatDateOnlyISO(new Date()),
            year: 0,
            yearlyNumber: 0,
            //phaseCode: 'M',  // FIXME: when we have Transformation, this should become modifiable on creation
            phaseCode: _currPhaseCode,
            clfTransportMeansId: 0,
            clfPortId: 0,
            clfReasonId: 0,
            clfPaymentTypeId: 0,
            clfPaymentStatusId: 0,
            clfPurposeId: 0,
            customerId: 0,
            destinationId: 0,
            destinationAddressId: 0,
            //carrierId: null,
            autoPrint: 0,
            printed: 0,
            weights: 1,
            deltaTeste: 0,
            deltaFrattaglie: 0,
            deltaPiedini: 0,
            visibleNotes: '',
            notes: '',
        });
    }
    else {
        let _resp = await TransportDocumentService.fetchTransportDocument(oid);
        record.set(_resp.payload);
    }
}
export async function search(phaseCode) {
    if (phaseCode != null) {
        let _filter = Object.assign({}, get(filter));
        _filter.criteria.phaseCodeId = phaseCode.oid; // note: this is already set by dropdown bind anyway
        _filter.criteria.phaseCode = phaseCode.code;
        filter.set(_filter);
    }
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await TransportDocumentService.getTransportDocuments(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/transport-document/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/transport-document/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await TransportDocumentService.saveTransportDocument(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await TransportDocumentService.deleteTransportDocument(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function onPrint() {
    let rec = get(record);
    if (rec == null || rec.oid == 0)
        return;
    await ReportService.exportPdfTransportDocument(rec.oid);
    // reload, because start transport might have changed
    setTimeout(() => initDetail(rec.oid), 100);
}
export async function downloadTracciabilitaReport() {
    let _record = get(record);
    if (_record != null && _record.oid != 0) {
        ReportService.exportPdfTracciabilita(_record.oid);
    }
}
